<script>
import Accordion from '@/components/Accordion/Main';
import AccordionItem from '@/components/Accordion/Item';

export default {
  props: {},
  components: {
    Accordion,
    AccordionItem,
  },
};
document.querySelector('#app').classList.add('overflow-hidden');
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <div class="flex flex-col lg:flex-row">
        <div class="w-full lg:w-2/3 xl:w-3/4 mr-5">
          <h2 class="title-h2 mb-6">Ответы на популярные вопросы</h2>
          <accordion>
            <accordion-item>
              <template #accordion-trigger>
                <p>
                  Как проверить техническое состояние подержанного автомобиля?
                </p>
              </template>

              <template #accordion-content>
                <p>
                  При покупке в&nbsp;&laquo;Прагматике&raquo; вы&nbsp;получаете
                  автомобиль с&nbsp;проведенной диагностикой и&nbsp;полным
                  отчетом о&nbsp;состоянии.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p>Можно&nbsp;ли купить автомобиль в&nbsp;кредит?</p>
              </template>

              <template #accordion-content>
                <p>
                  Да, мы&nbsp;предлагаем выгодные кредитные программы
                  с&nbsp;минимальной процентной ставкой.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p>Как работает программа Trade-In?</p>
              </template>

              <template #accordion-content>
                <p>
                  Программа Trade-In позволяет обменять ваш старый автомобиль
                  на&nbsp;автомобиль из&nbsp;каталога &laquo;Прагматики&raquo;.
                  Мы&nbsp;оцениваем вашу машину по&nbsp;рыночной стоимости,
                  после чего её&nbsp;цена засчитывается как часть оплаты
                  за&nbsp;выбранный автомобиль. Это удобный и&nbsp;быстрый
                  способ обновить транспортное средство без лишних хлопот.
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <p>Какие документы нужны для покупки авто с&nbsp;пробегом?</p>
              </template>

              <template #accordion-content>
                <p>
                  Для оформления покупки Volkswagen Transporter достаточно
                  паспорта и&nbsp;водительского удостоверения. Если
                  вы&nbsp;приобретаете автомобиль в&nbsp;кредит, может
                  потребоваться дополнительный пакет документов. Наши
                  специалисты помогут вам с&nbsp;оформлением всех необходимых
                  бумаг, чтобы процесс покупки был быстрым и&nbsp;комфортным.
                </p>
              </template>
            </accordion-item>
          </accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
p {
  color: #81869a;
}
</style>
